module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('photos-dialog', {
    attrs: {
      "bus": _vm.bus
    },
    on: {
      "submit": _vm.dialogSubmitted
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "drop",
    on: {
      "dragover": function($event) {
        $event.preventDefault();
      },
      "drop": _vm.onDrop
    }
  }, [(!_vm.value) ? _c('label', {
    staticClass: "btn display-inline"
  }, [_vm._v("\n            PRZECIĄGNIJ I UPUŚĆ, LUB\n            "), _c('input', {
    attrs: {
      "type": "file",
      "name": "value"
    },
    on: {
      "change": _vm.onChange
    }
  })]) : _c('div', {
    staticClass: "hidden",
    class: {
      'value': true
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.value,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.value) ? _c('el-button', {
    staticClass: "remove-button",
    attrs: {
      "size": "mini",
      "icon": "el-icon-delete",
      "type": "danger",
      "title": "Usuń zdjęcie"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeImage($event)
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-button', {
    staticClass: "open-dialog-button",
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.openDialog
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  }), _vm._v(" Wybierz z istniejących\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37d0eac4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageInputComponent.vue
// module id = 740
// module chunks = 0